import { useNavigate } from "react-router-dom";
import "./Css/ExamCreateForm.css";
import { useEffect, useState } from "react";
import profile from "./Images/Ellipse 24 (3).png";
import api from "../api/axios";
import API_BASE from "../config/api";

const SoftwareForm = () => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);

  const [standards, setStandards] = useState([]);

  const [formData, setFormData] = useState({
    softwareName: "",
    standardId: "",
    medium: "",
    subscriptionType: "",
    softwarePrice: "",
    studentCapacity: "",
    duration: "",
    profilePictureUrl: ""
  });

  /* ---------- Load standards ---------- */
  useEffect(() => {
    api.get(`${API_BASE}/api/softwares/standards`).then(res => {
      setStandards(res.data);
    });
  }, []);

  /* ---------- Image upload ---------- */
  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const data = new FormData();
    data.append("file", file);

    const res = await api.post(`${API_BASE}/api/softwares/upload-image`, data, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    setFormData(prev => ({
      ...prev,
      profilePictureUrl: res.data.imageUrl
    }));
  };

  const openPopup = () => {
    setShowPopup(true);
  };
  /* ---------- Save software ---------- */
  const confirmSave = async () => {
    await api.post(`${API_BASE}/api/softwares`, {
      softwareName: formData.softwareName,
      profilePictureUrl: formData.profilePictureUrl,
      medium: formData.medium || null,
      subscriptionType: Number(formData.subscriptionType),
      softwarePrice: Number(formData.softwarePrice),
      studentCapacity: Number(formData.studentCapacity),
      duration: Number(formData.duration),
      standardId: Number(formData.standardId)
    });

    setShowPopup(false);
    navigate("/dashboard/softwaremangment");
  };

  return (
    <div className="create-exam-wrapper">
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          सॉफ्टवेअर व्यवस्थापन  &gt;&gt; <span>नवीन सॉफ्टवेअर जोडा</span>
        </h3>

        <div className="edit-btnn">
          <button className="btn outlinee" onClick={() => navigate(-1)}>
            रद्द करा
          </button>
          <button className="btn primaryy" onClick={openPopup}>
            सेव्ह करा
          </button>
        </div>
      </div>

      <div className="create-exam-form">
        <h2>नवीन सॉफ्टवेअर जोडा</h2>

        <div className="profile-card">
          <div className="profile-img-wrapper">
            <img
              src={formData.profilePictureUrl || profile}
              alt="student"
              className="profile-img"
            />

            <label className="edit-icon">
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                hidden
              />
            </label>
          </div>
        </div>

        <div className="form-grid">
          <div className="form-group">
            <label>सॉफ्टवेअर नाव</label>
            <input
              type="text"
              placeholder=" सॉफ्टवेअर नाव इथे टाका "
              onChange={e =>
                setFormData({ ...formData, softwareName: e.target.value })
              }
            />
          </div>

          <div className="form-group">
            <label>इयत्ता</label>
            <select
              onChange={e =>
                setFormData({ ...formData, standardId: e.target.value })
              }
            >
              <option>इयत्ता</option>
              {standards.map(s => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>माध्यम</label>
            <select
              onChange={e =>
                setFormData({ ...formData, medium: e.target.value })
              }
            >
              <option>माध्यम</option>
              <option value="Marathi">मराठी</option>
              <option value="English">इंग्लिश</option>
            </select>
          </div>

          <div className="form-group">
            <label>सबस्क्रिप्शन स्टॅंडर्ड</label>
            <select
              onChange={e =>
                setFormData({ ...formData, subscriptionType: e.target.value })
              }
            >
              <option>सबस्क्रिप्शन स्टॅंडर्ड</option>
              <option value="1">बेसिक</option>
              <option value="2">स्टॅंडर्ड</option>
              <option value="3">प्रीमियम</option>
            </select>
          </div>

          <div className="form-group">
            <label>सॉफ्टवेअर किंमत</label>
            <input
              type="text"
              placeholder="सॉफ्टवेअर किंमत इथे टाका "
              onChange={e =>
                setFormData({ ...formData, softwarePrice: e.target.value })
              }
            />
          </div>

          <div className="form-group">
            <label>विद्यार्थी मर्यादा</label>
            <input
              type="text"
              placeholder="विद्यार्थी मर्यादा इथे टाका "
              onChange={e =>
                setFormData({ ...formData, studentCapacity: e.target.value })
              }
            />
          </div>

          <div className="form-group">
            <label>सबस्क्रिप्शन कालावधी</label>
            <select
              onChange={e =>
                setFormData({ ...formData, duration: e.target.value })
              }
            >
              <option>सबस्क्रिप्शन कालावधी</option>
              <option value="2">वार्षिक</option>
              <option value="1">मासिक</option>
            </select>
          </div>
        </div>
      </div>

      {showPopup && (
        <div className="exam-popup-overlay">
          <div className="exam-popup-card">
            <h3>सॉफ्टवेअर प्रकाशित केले गेले आहे.</h3>
            <p>आता हे सर्व संस्थांना वेबसाईट वर उपलब्ध आहे.</p>

            <div className="exam-popup-actions">
              <button
                className="exam-popup-btn primary"
                onClick={confirmSave}
              >
                ठीक आहे
              </button>
            </div>

            <span
              className="exam-popup-close"
              onClick={() => setShowPopup(false)}
            >
              ✕
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default SoftwareForm;
